// Copyright (c) 2024 Merit International Inc. All Rights Reserved.

import { create } from "zustand";
import type { TemplateIdsByTemplateFieldId } from "../types";

type TemplateIdsByTemplateFieldIdData = {
  readonly templateIdsByTemplateFieldId: TemplateIdsByTemplateFieldId;
};

type TemplateIdsByTemplateFieldIdFunctions = {
  readonly setTemplateIdsByTemplateFieldId: (
    templateIdsByTemplateFieldId: TemplateIdsByTemplateFieldId
  ) => void;
};

/* eslint-disable sort-keys-fix/sort-keys-fix */
const initialState: TemplateIdsByTemplateFieldIdData = {
  templateIdsByTemplateFieldId: {},
};

export const useTemplateIdsByTemplateFieldIdStore = create<
  TemplateIdsByTemplateFieldIdData & TemplateIdsByTemplateFieldIdFunctions
>()(set => ({
  ...initialState,

  setTemplateIdsByTemplateFieldId: templateIdsByTemplateFieldId => {
    set(() => ({ templateIdsByTemplateFieldId }));
  },
}));
/* eslint-enable sort-keys-fix/sort-keys-fix */
